type IconProps = React.ComponentProps<'svg'>

export function Cube04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.95028 0.00008c0.12755 0 0.26873-0.00011 0.38965 0.00977 0.12968 0.01062 0.30093 0.03699 0.47754 0.12695 0.23508 0.11981 0.42607 0.31083 0.5459 0.5459 0.08998 0.1766 0.11632 0.34784 0.12695 0.47754 0.00988 0.12091 0.00977 0.26208 0.00977 0.38965l0 11.53711c0 0.20885 0.00431 0.43578-0.04883 0.65723-0.04285 0.1785-0.11309 0.34933-0.20899 0.50586-0.11901 0.19421-0.28296 0.35132-0.43066 0.49902l-4.0625 4.0625c-0.14771 0.14771-0.30482 0.31165-0.49902 0.43066-0.15653 0.0959-0.32736 0.16613-0.50586 0.20899-0.22144 0.05314-0.44837 0.04883-0.65723 0.04883l-11.53711 0c-0.12756 0-0.26874 0.00011-0.38965-0.00977-0.1297-0.01063-0.30094-0.03697-0.47754-0.12695-0.23507-0.11983-0.42609-0.31081-0.5459-0.5459-0.08996-0.17661-0.11633-0.34785-0.12695-0.47754-0.00987-0.12092-0.00977-0.26209-0.00977-0.38965l0-11.53711c0-0.20885-0.00432-0.43579 0.04883-0.65723 0.04286-0.17849 0.11309-0.34934 0.20899-0.50586 0.11901-0.1942 0.28296-0.35132 0.43066-0.49902l4.0625-4.0625c0.1477-0.1477 0.30483-0.31165 0.49902-0.43066 0.15652-0.09589 0.32737-0.16613 0.50586-0.20899 0.22143-0.05315 0.44838-0.04883 0.65723-0.04883l11.53711 0z m-15.38965 18.00001l10.43946 0 0-3.5-6.93946 0-3.5 3.5z m-1.06054-1.06055l3.49999-3.5 0-6.93946-3.49999 0 0 10.43946z m13 0l2.43945-2.43945-2.43945 0 0 2.43945z m-8.00001-3.93945l6.5 0 0-6.50001-6.5 0 0 6.5z m8-6.93946l0 6.93946 3.50001 0 0-10.43946-3.50001 3.5z m-11.93945-1.06055l2.43945 0 0-2.43945-2.43945 2.43945z m3.93945 0l6.93946 0 3.5-3.49999-10.43946 0 0 3.49999z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
